import React, { useEffect, useState } from 'react';
import ModalContainer from '../../components/ModalContainer.jsx';
import { Form, Formik } from 'formik';
import GetField from '../../components/GetField.jsx';
import Alert from '../../utils/Alert.js';
import { getSingleInstallmentService } from '../../services/installmentsServices.js';
import { initialTouched, initialValues, onSubmit, validationSchema } from './addInstallmentFormikCodes.js';
import { convertDateToJalaali } from '../../utils/convertDate.js';

const AddInstallment = ({
    isOpen,
    setIsOpen,
    setInstallments,
    editingId,
    setEditingId,
    orderData
}) => {
    const [editingInstallment, setEditingInstallment] = useState(null);
    const [reinitializeValues, setReinitializeValues] = useState(null);

    const handleGetInstallmentData = async (installmentId) => {
        try {
            const response = await getSingleInstallmentService(orderData.code, installmentId);
            if (response.status === 200) {
                setEditingInstallment(response.data);
            }
        } catch (error) {
            Alert(`خطا ${error.response?.status || ""}!`, "در دریافت جزئیات قسط مشکلی رخ داده است!\nلطفاً مجدداً تلاش کنید.", "error");
            return setIsOpen(false);
        } finally {
        }
    }

    useEffect(() => {
        if (editingId) {
            handleGetInstallmentData(editingId);
        } else {
            setEditingInstallment(null);
        }
    }, [editingId]);

    useEffect(() => {
        if (editingInstallment) {
            setReinitializeValues({
                amount: editingInstallment.amount,
                pay_date: convertDateToJalaali(editingInstallment.pay_date),
                is_paid: editingInstallment.is_paid
            });
        } else {
            setReinitializeValues(null);
        }
    }, [editingInstallment]);

    return (
        <ModalContainer
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            fullscreen={false}
            title={editingId ? `ویرایش قسط "${editingId}"` : "ایجاد قسط"}
            onClose={() => {
                setEditingId(null);
                setEditingInstallment(null);
                setIsOpen(false);
            }}
            keepMounted={false}
        >
            <Formik
                initialValues={reinitializeValues || initialValues}
                initialTouched={reinitializeValues ? initialTouched : {}}
                onSubmit={(values, actions) => onSubmit(values, actions, editingInstallment, setInstallments, setIsOpen, orderData, setEditingId, setEditingInstallment)}
                validationSchema={validationSchema}
                enableReinitialize
                validateOnMount
            >
                {(formik) => {
                    return (
                        <Form className="flex flex-col items-center">
                            <div className="mt-2 mb-4 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="amount"
                                    type="text"
                                    placeholder="مبلغ تخفیف"
                                    label="مبلغ"
                                    formik={formik}
                                />
                            </div>
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="datepicker"
                                    name="pay_date"
                                    label="مهلت پرداخت:"
                                    placeholder="تاریخ مهلت پرداخت"
                                    formik={formik}
                                    yearRange={{
                                        from: 2, to: 10
                                    }}
                                    initialDate={editingInstallment ? editingInstallment.pay_date : ""}
                                />
                            </div>
                            <div className="mb-4 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="switch"
                                    name="is_paid"
                                    label="پرداخت شده"
                                />
                            </div>
                            <div className="mt-2 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="submitbutton"
                                    disabledButton={true}
                                    formik={formik}
                                    text={editingId ? "ویرایش قسط" : "ایجاد قسط"}
                                />
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </ModalContainer>
    );
}

export default AddInstallment;
